'use client';

interface ContestHeroProps {
  heroImageUrl: string;
  mobileImageUrl?: string;
}

/**
 * ContestHero - Hero image section.
 *
 * Renders a responsive picture element that switches between
 * desktop and mobile image sources.
 */
export function ContestHero({ heroImageUrl, mobileImageUrl }: ContestHeroProps) {
  const mobileImg = mobileImageUrl ?? heroImageUrl;

  return (
    <>
      <style>{`
        .contest-hero {
          position: relative;
          width: 100%;
        }
        .contest-hero__img {
          display: block;
          width: 100%;
          height: auto;
        }
      `}</style>
      <div className="contest-hero">
        <picture>
          <source media="(max-width: 768px)" srcSet={mobileImg} />
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className="contest-hero__img" src={heroImageUrl} alt="" />
        </picture>
      </div>
    </>
  );
}
